/* @flow */
import { getterFromKeyPath } from 'trustar/utils';
import createDebugger from 'debug';
const debug = createDebugger('app:modules:chat:getters'); // eslint-disable-line no-unused-vars

// Slack Community Chat
export const joinRequestInProgress = getterFromKeyPath(['chat', 'joinRequestInProgress']);
export const slackInvitationStatus = getterFromKeyPath(['chat', 'slackInvitationStatus']);
// END Slack Community Chat


// WEBPACK FOOTER //
// ./src/app/modules/chat/getters.js